export default {
	titleFieldLabel: "Goal name",
	titleFieldHint: "Short, clear, aspirational, and achievable within a given cycle.",
	titleFieldPlaceholder: "e.g. Achieve record revenue and profitability",
	assignedTeamIdFieldLabel: "Team / 1:1",
	assignedTeamIdFieldHint: "Once a goal is saved, assignment to a team or 1:1 cannot be changed.",
	confidenceLevelFieldLabel: "Confidence",
	confidenceLevelFieldHint: "Your level of confidence that this goal will be completed on time.",
	startDateFieldLabel: "Start date",
	startDateFieldHint: "Defaults to today.",
	endDateFieldLabel: "End (target) date",
	endDateFieldHint: "Defaults to +90 days.",
	commentFieldLabel: "Comment",
	commentFieldOptionalLabel: "Optional",
	commentFieldHint: "Add a comment to give context to any changes you make. Comments appear in the goal’s activity feed.",
	commentFieldPlaceholder: "Leave a comment",
};
